import {
  IS_NEW_ARRIVAL,
  IS_NEAR_DEDLINE,
  EMPLOYMENT_STATUS_MAPPING,
  HOLIDAY_AND_WAY_OF_WORKING_MAPPING,
  REQUIREMENTS_MAPPING,
  WORKPLACE_ENVIRONMENT_MAPPING,
  WELFARE_BENEFITS_MAPPING,
  LANGUAGE_SKILLS_MAPPING,
  POSITIONS_MAPPING,
  EMPLOYEE_AVERAGE_AGE_MAPPING,
} from '@doda/common/src/constants/hydrogenOldParamMap';
import { QUERY_PARAMS } from '@doda/common/src/constants/queryParams';

// 直接変換が可能なパラメータ
export const DIRECT_SAVE_SEARCHES_REQUEST_TO_OLD_PARAM_MAPPING = {
  areaIdList: QUERY_PARAMS.ar,
  prefectureIdList: QUERY_PARAMS.pr,
  cityIdList: QUERY_PARAMS.ci,
  wardIdList: QUERY_PARAMS.wa,
  routeIdList: QUERY_PARAMS.rt,
  stationIdList: QUERY_PARAMS.st,
  searchJobTypeLIdList: QUERY_PARAMS.oc,
  searchJobTypeMIdList: QUERY_PARAMS.oc,
  searchJobTypeSIdList: QUERY_PARAMS.oc,
  industryLIdList: QUERY_PARAMS.ind,
  industrySIdList: QUERY_PARAMS.ind,
  includedKeywordList: QUERY_PARAMS.k,
  excludedKeywordList: QUERY_PARAMS.ni,
};

export const STANDARD_MAPPING = {
  areaIdList: QUERY_PARAMS.ar,
  prefectureIdList: QUERY_PARAMS.pr,
  cityIdList: QUERY_PARAMS.ci,
  wardIdList: QUERY_PARAMS.wa,
  routeIdList: QUERY_PARAMS.rt,
  stationIdList: QUERY_PARAMS.st,
  includedKeywordList: QUERY_PARAMS.k,
  excludedKeywordList: QUERY_PARAMS.ni,
  establishList: QUERY_PARAMS.es,
  employNumList: QUERY_PARAMS.ne,
};

export const CONCAT_NEEDED_MAPPING = {
  searchJobTypeLIdList: QUERY_PARAMS.oc,
  searchJobTypeMIdList: QUERY_PARAMS.oc,
  searchJobTypeSIdList: QUERY_PARAMS.oc,
  industryLIdList: QUERY_PARAMS.ind,
  industrySIdList: QUERY_PARAMS.ind,
};

export const OP_VALUE_MAPPINGS = {
  isNewArrival: IS_NEW_ARRIVAL,
  isNearDeadline: IS_NEAR_DEDLINE,
  employmentStatusList: EMPLOYMENT_STATUS_MAPPING,
  holidayAndWayOfWorkingList: HOLIDAY_AND_WAY_OF_WORKING_MAPPING,
  requirementsList: REQUIREMENTS_MAPPING,
  workplaceEnvironmentList: WORKPLACE_ENVIRONMENT_MAPPING,
  welfareBenefitsList: WELFARE_BENEFITS_MAPPING,
  languageSkillsList: LANGUAGE_SKILLS_MAPPING,
  positionsList: POSITIONS_MAPPING,
  employeeAverageAgeList: EMPLOYEE_AVERAGE_AGE_MAPPING,
};
